export enum EClientProfileTab {
  CLIENT_INFO = 'client-info',
  BUSINESS_ADDRESS = 'business-address',
  SHIPPING_ADDRESS = 'shipping-address',
}

export const CLIENT_PROFILE_TABS = [
  {
    name: EClientProfileTab.CLIENT_INFO,
    label: 'Client Info',
    icon: {
      name: 'edit-book',
      width: 24,
      height: 24,
    },
    disabled: false,
  },
  {
    name: EClientProfileTab.BUSINESS_ADDRESS,
    label: 'Business Address',
    icon: {
      name: 'shopping-store-2',
      width: 18,
      height: 18,
    },
    disabled: true,
  },
  {
    name: EClientProfileTab.SHIPPING_ADDRESS,
    label: 'Shipping Address',
    icon: {
      name: 'shipping',
      width: 32,
      height: 32,
    },
    disabled: true,
  },
];
